import useAuth from '@rhg/libs/auth0/use-auth';
import { getIsSamlUserToken } from '@rhg/utils/sso';

export function useIsSamlUser() {
    const { user } = useAuth();
    return getIsSamlUserToken(user);
}
